// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "schedule.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "schedule.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleShift$Type extends MessageType {
    constructor() {
        super("ScheduleShift", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "shift_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "superintendent_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "event_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "draft_on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "draft_end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "card_draft_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.shiftTypeId = 0;
        message.onSiteTime = "";
        message.superintendentUserId = 0;
        message.isActive = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.eventIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.weekStart = "";
        message.endTime = "";
        message.draftOnSiteTime = "";
        message.draftEndTime = "";
        message.cardDraftId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 shift_type_id */ 3:
                    message.shiftTypeId = reader.int32();
                    break;
                case /* string on_site_time */ 4:
                    message.onSiteTime = reader.string();
                    break;
                case /* int32 superintendent_user_id */ 5:
                    message.superintendentUserId = reader.int32();
                    break;
                case /* int32 is_active */ 6:
                    message.isActive = reader.int32();
                    break;
                case /* int32 created_by */ 7:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 9:
                    message.updatedAt = reader.string();
                    break;
                case /* string event_id_list */ 10:
                    message.eventIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 11:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 12:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 13:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 14:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 15:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string week_start */ 16:
                    message.weekStart = reader.string();
                    break;
                case /* string end_time */ 17:
                    message.endTime = reader.string();
                    break;
                case /* string draft_on_site_time */ 18:
                    message.draftOnSiteTime = reader.string();
                    break;
                case /* string draft_end_time */ 19:
                    message.draftEndTime = reader.string();
                    break;
                case /* int32 card_draft_id */ 20:
                    message.cardDraftId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 shift_type_id = 3; */
        if (message.shiftTypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.shiftTypeId);
        /* string on_site_time = 4; */
        if (message.onSiteTime !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.onSiteTime);
        /* int32 superintendent_user_id = 5; */
        if (message.superintendentUserId !== 0)
            writer.tag(5, WireType.Varint).int32(message.superintendentUserId);
        /* int32 is_active = 6; */
        if (message.isActive !== 0)
            writer.tag(6, WireType.Varint).int32(message.isActive);
        /* int32 created_by = 7; */
        if (message.createdBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.createdBy);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 9; */
        if (message.updatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updatedAt);
        /* string event_id_list = 10; */
        if (message.eventIdList !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.eventIdList);
        /* repeated string field_mask = 11; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 12; */
        if (message.pageNumber !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 13; */
        if (message.orderBy !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 14; */
        if (message.orderDir !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 15; */
        if (message.withoutLimit !== false)
            writer.tag(15, WireType.Varint).bool(message.withoutLimit);
        /* string week_start = 16; */
        if (message.weekStart !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.weekStart);
        /* string end_time = 17; */
        if (message.endTime !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.endTime);
        /* string draft_on_site_time = 18; */
        if (message.draftOnSiteTime !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.draftOnSiteTime);
        /* string draft_end_time = 19; */
        if (message.draftEndTime !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.draftEndTime);
        /* int32 card_draft_id = 20; */
        if (message.cardDraftId !== 0)
            writer.tag(20, WireType.Varint).int32(message.cardDraftId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleShift
 */
export const ScheduleShift = new ScheduleShift$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleShiftList$Type extends MessageType {
    constructor() {
        super("ScheduleShiftList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleShift },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleShift results */ 1:
                    message.results.push(ScheduleShift.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleShift results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleShift.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleShiftList
 */
export const ScheduleShiftList = new ScheduleShiftList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleCardDraft$Type extends MessageType {
    constructor() {
        super("ScheduleCardDraft", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "publish_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.scheduleId = 0;
        message.onSiteTime = "";
        message.endTime = "";
        message.publishId = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.isActive = 0;
        message.scheduleIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* string on_site_time */ 3:
                    message.onSiteTime = reader.string();
                    break;
                case /* string end_time */ 4:
                    message.endTime = reader.string();
                    break;
                case /* int32 publish_id */ 5:
                    message.publishId = reader.int32();
                    break;
                case /* int32 created_by */ 6:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 7:
                    message.createdAt = reader.string();
                    break;
                case /* int32 is_active */ 8:
                    message.isActive = reader.int32();
                    break;
                case /* string schedule_id_list */ 9:
                    message.scheduleIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 12:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 13:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 14:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* string on_site_time = 3; */
        if (message.onSiteTime !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.onSiteTime);
        /* string end_time = 4; */
        if (message.endTime !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.endTime);
        /* int32 publish_id = 5; */
        if (message.publishId !== 0)
            writer.tag(5, WireType.Varint).int32(message.publishId);
        /* int32 created_by = 6; */
        if (message.createdBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.createdBy);
        /* string created_at = 7; */
        if (message.createdAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.createdAt);
        /* int32 is_active = 8; */
        if (message.isActive !== 0)
            writer.tag(8, WireType.Varint).int32(message.isActive);
        /* string schedule_id_list = 9; */
        if (message.scheduleIdList !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.scheduleIdList);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 12; */
        if (message.orderBy !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 13; */
        if (message.orderDir !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 14; */
        if (message.withoutLimit !== false)
            writer.tag(14, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleCardDraft
 */
export const ScheduleCardDraft = new ScheduleCardDraft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleCardDraftList$Type extends MessageType {
    constructor() {
        super("ScheduleCardDraftList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleCardDraft },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleCardDraft results */ 1:
                    message.results.push(ScheduleCardDraft.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleCardDraft results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleCardDraft.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleCardDraftList
 */
export const ScheduleCardDraftList = new ScheduleCardDraftList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleAssignment$Type extends MessageType {
    constructor() {
        super("ScheduleAssignment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "assignment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "entry_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "role_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "publish_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "timeoff_override", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "timeoff_override_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "shift_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "schedule_on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "superintendent_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "counts_as_booked", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "job_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "parent_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "user_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "user_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "user_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "user_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "timeoff_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "event_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 39, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 42, name: "job_department_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "schedule_end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "visit_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 46, name: "seen_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.scheduleId = 0;
        message.userId = 0;
        message.assignmentDate = "";
        message.entryTypeId = 0;
        message.roleId = 0;
        message.onSiteTime = "";
        message.note = "";
        message.publishId = 0;
        message.timeoffOverride = 0;
        message.timeoffOverrideNote = "";
        message.isActive = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.eventId = 0;
        message.shiftTypeId = 0;
        message.scheduleOnSiteTime = "";
        message.superintendentUserId = 0;
        message.countsAsBooked = 0;
        message.jobNumber = "";
        message.jobName = "";
        message.jobDepartmentId = 0;
        message.parentEventId = 0;
        message.propertyId = 0;
        message.propertyCity = "";
        message.userFirstname = "";
        message.userLastname = "";
        message.userDepartmentId = 0;
        message.userCity = "";
        message.timeoffLevel = 0;
        message.dateRange = [];
        message.dateTarget = [];
        message.userIdList = "";
        message.scheduleIdList = "";
        message.eventIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.jobDepartmentIdList = "";
        message.endTime = "";
        message.scheduleEndTime = "";
        message.visitOrder = 0;
        message.seenAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string assignment_date */ 4:
                    message.assignmentDate = reader.string();
                    break;
                case /* int32 entry_type_id */ 5:
                    message.entryTypeId = reader.int32();
                    break;
                case /* int32 role_id */ 6:
                    message.roleId = reader.int32();
                    break;
                case /* string on_site_time */ 7:
                    message.onSiteTime = reader.string();
                    break;
                case /* string note */ 8:
                    message.note = reader.string();
                    break;
                case /* int32 publish_id */ 9:
                    message.publishId = reader.int32();
                    break;
                case /* int32 timeoff_override */ 10:
                    message.timeoffOverride = reader.int32();
                    break;
                case /* string timeoff_override_note */ 11:
                    message.timeoffOverrideNote = reader.string();
                    break;
                case /* int32 is_active */ 12:
                    message.isActive = reader.int32();
                    break;
                case /* int32 created_by */ 13:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 14:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 15:
                    message.updatedAt = reader.string();
                    break;
                case /* int32 event_id */ 16:
                    message.eventId = reader.int32();
                    break;
                case /* int32 shift_type_id */ 17:
                    message.shiftTypeId = reader.int32();
                    break;
                case /* string schedule_on_site_time */ 18:
                    message.scheduleOnSiteTime = reader.string();
                    break;
                case /* int32 superintendent_user_id */ 19:
                    message.superintendentUserId = reader.int32();
                    break;
                case /* int32 counts_as_booked */ 20:
                    message.countsAsBooked = reader.int32();
                    break;
                case /* string job_number */ 21:
                    message.jobNumber = reader.string();
                    break;
                case /* string job_name */ 22:
                    message.jobName = reader.string();
                    break;
                case /* int32 job_department_id */ 23:
                    message.jobDepartmentId = reader.int32();
                    break;
                case /* int32 parent_event_id */ 24:
                    message.parentEventId = reader.int32();
                    break;
                case /* int32 property_id */ 25:
                    message.propertyId = reader.int32();
                    break;
                case /* string property_city */ 26:
                    message.propertyCity = reader.string();
                    break;
                case /* string user_firstname */ 27:
                    message.userFirstname = reader.string();
                    break;
                case /* string user_lastname */ 28:
                    message.userLastname = reader.string();
                    break;
                case /* int32 user_department_id */ 29:
                    message.userDepartmentId = reader.int32();
                    break;
                case /* string user_city */ 30:
                    message.userCity = reader.string();
                    break;
                case /* int32 timeoff_level */ 31:
                    message.timeoffLevel = reader.int32();
                    break;
                case /* repeated string date_range */ 32:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 33:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string user_id_list */ 34:
                    message.userIdList = reader.string();
                    break;
                case /* string schedule_id_list */ 35:
                    message.scheduleIdList = reader.string();
                    break;
                case /* string event_id_list */ 36:
                    message.eventIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 37:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 38:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 39:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 40:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 41:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string job_department_id_list */ 42:
                    message.jobDepartmentIdList = reader.string();
                    break;
                case /* string end_time */ 43:
                    message.endTime = reader.string();
                    break;
                case /* string schedule_end_time */ 44:
                    message.scheduleEndTime = reader.string();
                    break;
                case /* int32 visit_order */ 45:
                    message.visitOrder = reader.int32();
                    break;
                case /* string seen_at */ 46:
                    message.seenAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string assignment_date = 4; */
        if (message.assignmentDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.assignmentDate);
        /* int32 entry_type_id = 5; */
        if (message.entryTypeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.entryTypeId);
        /* int32 role_id = 6; */
        if (message.roleId !== 0)
            writer.tag(6, WireType.Varint).int32(message.roleId);
        /* string on_site_time = 7; */
        if (message.onSiteTime !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.onSiteTime);
        /* string note = 8; */
        if (message.note !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.note);
        /* int32 publish_id = 9; */
        if (message.publishId !== 0)
            writer.tag(9, WireType.Varint).int32(message.publishId);
        /* int32 timeoff_override = 10; */
        if (message.timeoffOverride !== 0)
            writer.tag(10, WireType.Varint).int32(message.timeoffOverride);
        /* string timeoff_override_note = 11; */
        if (message.timeoffOverrideNote !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.timeoffOverrideNote);
        /* int32 is_active = 12; */
        if (message.isActive !== 0)
            writer.tag(12, WireType.Varint).int32(message.isActive);
        /* int32 created_by = 13; */
        if (message.createdBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.createdBy);
        /* string created_at = 14; */
        if (message.createdAt !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 15; */
        if (message.updatedAt !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.updatedAt);
        /* int32 event_id = 16; */
        if (message.eventId !== 0)
            writer.tag(16, WireType.Varint).int32(message.eventId);
        /* int32 shift_type_id = 17; */
        if (message.shiftTypeId !== 0)
            writer.tag(17, WireType.Varint).int32(message.shiftTypeId);
        /* string schedule_on_site_time = 18; */
        if (message.scheduleOnSiteTime !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.scheduleOnSiteTime);
        /* int32 superintendent_user_id = 19; */
        if (message.superintendentUserId !== 0)
            writer.tag(19, WireType.Varint).int32(message.superintendentUserId);
        /* int32 counts_as_booked = 20; */
        if (message.countsAsBooked !== 0)
            writer.tag(20, WireType.Varint).int32(message.countsAsBooked);
        /* string job_number = 21; */
        if (message.jobNumber !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.jobNumber);
        /* string job_name = 22; */
        if (message.jobName !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.jobName);
        /* int32 job_department_id = 23; */
        if (message.jobDepartmentId !== 0)
            writer.tag(23, WireType.Varint).int32(message.jobDepartmentId);
        /* int32 parent_event_id = 24; */
        if (message.parentEventId !== 0)
            writer.tag(24, WireType.Varint).int32(message.parentEventId);
        /* int32 property_id = 25; */
        if (message.propertyId !== 0)
            writer.tag(25, WireType.Varint).int32(message.propertyId);
        /* string property_city = 26; */
        if (message.propertyCity !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.propertyCity);
        /* string user_firstname = 27; */
        if (message.userFirstname !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.userFirstname);
        /* string user_lastname = 28; */
        if (message.userLastname !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.userLastname);
        /* int32 user_department_id = 29; */
        if (message.userDepartmentId !== 0)
            writer.tag(29, WireType.Varint).int32(message.userDepartmentId);
        /* string user_city = 30; */
        if (message.userCity !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.userCity);
        /* int32 timeoff_level = 31; */
        if (message.timeoffLevel !== 0)
            writer.tag(31, WireType.Varint).int32(message.timeoffLevel);
        /* repeated string date_range = 32; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(32, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 33; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(33, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string user_id_list = 34; */
        if (message.userIdList !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.userIdList);
        /* string schedule_id_list = 35; */
        if (message.scheduleIdList !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.scheduleIdList);
        /* string event_id_list = 36; */
        if (message.eventIdList !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.eventIdList);
        /* repeated string field_mask = 37; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(37, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 38; */
        if (message.pageNumber !== 0)
            writer.tag(38, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 39; */
        if (message.orderBy !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 40; */
        if (message.orderDir !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 41; */
        if (message.withoutLimit !== false)
            writer.tag(41, WireType.Varint).bool(message.withoutLimit);
        /* string job_department_id_list = 42; */
        if (message.jobDepartmentIdList !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.jobDepartmentIdList);
        /* string end_time = 43; */
        if (message.endTime !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.endTime);
        /* string schedule_end_time = 44; */
        if (message.scheduleEndTime !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.scheduleEndTime);
        /* int32 visit_order = 45; */
        if (message.visitOrder !== 0)
            writer.tag(45, WireType.Varint).int32(message.visitOrder);
        /* string seen_at = 46; */
        if (message.seenAt !== "")
            writer.tag(46, WireType.LengthDelimited).string(message.seenAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleAssignment
 */
export const ScheduleAssignment = new ScheduleAssignment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleAssignmentList$Type extends MessageType {
    constructor() {
        super("ScheduleAssignmentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleAssignment },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleAssignment results */ 1:
                    message.results.push(ScheduleAssignment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleAssignment results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleAssignment.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleAssignmentList
 */
export const ScheduleAssignmentList = new ScheduleAssignmentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleAssignmentBoard$Type extends MessageType {
    constructor() {
        super("ScheduleAssignmentBoard", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "assignment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "entry_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "role_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "publish_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "timeoff_override", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "timeoff_override_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "shift_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "schedule_on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "superintendent_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "counts_as_booked", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "job_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "parent_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "user_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "user_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "user_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "user_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "timeoff_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "is_draft", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "pending_removal", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "published_assignment_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "published_entry_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 36, name: "published_role_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 37, name: "published_on_site_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "published_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "event_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "job_department_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 47, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 48, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 50, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 51, name: "schedule_end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 52, name: "published_end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 53, name: "visit_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 54, name: "published_visit_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 55, name: "seen_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 56, name: "published_seen_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.scheduleId = 0;
        message.userId = 0;
        message.assignmentDate = "";
        message.entryTypeId = 0;
        message.roleId = 0;
        message.onSiteTime = "";
        message.note = "";
        message.publishId = 0;
        message.timeoffOverride = 0;
        message.timeoffOverrideNote = "";
        message.isActive = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.eventId = 0;
        message.shiftTypeId = 0;
        message.scheduleOnSiteTime = "";
        message.superintendentUserId = 0;
        message.countsAsBooked = 0;
        message.jobNumber = "";
        message.jobName = "";
        message.jobDepartmentId = 0;
        message.parentEventId = 0;
        message.propertyId = 0;
        message.propertyCity = "";
        message.userFirstname = "";
        message.userLastname = "";
        message.userDepartmentId = 0;
        message.userCity = "";
        message.timeoffLevel = 0;
        message.isDraft = 0;
        message.pendingRemoval = 0;
        message.publishedAssignmentId = 0;
        message.publishedEntryTypeId = 0;
        message.publishedRoleId = 0;
        message.publishedOnSiteTime = "";
        message.publishedNote = "";
        message.dateRange = [];
        message.dateTarget = [];
        message.userIdList = "";
        message.scheduleIdList = "";
        message.eventIdList = "";
        message.jobDepartmentIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.endTime = "";
        message.scheduleEndTime = "";
        message.publishedEndTime = "";
        message.visitOrder = 0;
        message.publishedVisitOrder = 0;
        message.seenAt = "";
        message.publishedSeenAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string assignment_date */ 4:
                    message.assignmentDate = reader.string();
                    break;
                case /* int32 entry_type_id */ 5:
                    message.entryTypeId = reader.int32();
                    break;
                case /* int32 role_id */ 6:
                    message.roleId = reader.int32();
                    break;
                case /* string on_site_time */ 7:
                    message.onSiteTime = reader.string();
                    break;
                case /* string note */ 8:
                    message.note = reader.string();
                    break;
                case /* int32 publish_id */ 9:
                    message.publishId = reader.int32();
                    break;
                case /* int32 timeoff_override */ 10:
                    message.timeoffOverride = reader.int32();
                    break;
                case /* string timeoff_override_note */ 11:
                    message.timeoffOverrideNote = reader.string();
                    break;
                case /* int32 is_active */ 12:
                    message.isActive = reader.int32();
                    break;
                case /* int32 created_by */ 13:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 14:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 15:
                    message.updatedAt = reader.string();
                    break;
                case /* int32 event_id */ 16:
                    message.eventId = reader.int32();
                    break;
                case /* int32 shift_type_id */ 17:
                    message.shiftTypeId = reader.int32();
                    break;
                case /* string schedule_on_site_time */ 18:
                    message.scheduleOnSiteTime = reader.string();
                    break;
                case /* int32 superintendent_user_id */ 19:
                    message.superintendentUserId = reader.int32();
                    break;
                case /* int32 counts_as_booked */ 20:
                    message.countsAsBooked = reader.int32();
                    break;
                case /* string job_number */ 21:
                    message.jobNumber = reader.string();
                    break;
                case /* string job_name */ 22:
                    message.jobName = reader.string();
                    break;
                case /* int32 job_department_id */ 23:
                    message.jobDepartmentId = reader.int32();
                    break;
                case /* int32 parent_event_id */ 24:
                    message.parentEventId = reader.int32();
                    break;
                case /* int32 property_id */ 25:
                    message.propertyId = reader.int32();
                    break;
                case /* string property_city */ 26:
                    message.propertyCity = reader.string();
                    break;
                case /* string user_firstname */ 27:
                    message.userFirstname = reader.string();
                    break;
                case /* string user_lastname */ 28:
                    message.userLastname = reader.string();
                    break;
                case /* int32 user_department_id */ 29:
                    message.userDepartmentId = reader.int32();
                    break;
                case /* string user_city */ 30:
                    message.userCity = reader.string();
                    break;
                case /* int32 timeoff_level */ 31:
                    message.timeoffLevel = reader.int32();
                    break;
                case /* int32 is_draft */ 32:
                    message.isDraft = reader.int32();
                    break;
                case /* int32 pending_removal */ 33:
                    message.pendingRemoval = reader.int32();
                    break;
                case /* int32 published_assignment_id */ 34:
                    message.publishedAssignmentId = reader.int32();
                    break;
                case /* int32 published_entry_type_id */ 35:
                    message.publishedEntryTypeId = reader.int32();
                    break;
                case /* int32 published_role_id */ 36:
                    message.publishedRoleId = reader.int32();
                    break;
                case /* string published_on_site_time */ 37:
                    message.publishedOnSiteTime = reader.string();
                    break;
                case /* string published_note */ 38:
                    message.publishedNote = reader.string();
                    break;
                case /* repeated string date_range */ 39:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 40:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string user_id_list */ 41:
                    message.userIdList = reader.string();
                    break;
                case /* string schedule_id_list */ 42:
                    message.scheduleIdList = reader.string();
                    break;
                case /* string event_id_list */ 43:
                    message.eventIdList = reader.string();
                    break;
                case /* string job_department_id_list */ 44:
                    message.jobDepartmentIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 45:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 46:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 47:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 48:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 49:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string end_time */ 50:
                    message.endTime = reader.string();
                    break;
                case /* string schedule_end_time */ 51:
                    message.scheduleEndTime = reader.string();
                    break;
                case /* string published_end_time */ 52:
                    message.publishedEndTime = reader.string();
                    break;
                case /* int32 visit_order */ 53:
                    message.visitOrder = reader.int32();
                    break;
                case /* int32 published_visit_order */ 54:
                    message.publishedVisitOrder = reader.int32();
                    break;
                case /* string seen_at */ 55:
                    message.seenAt = reader.string();
                    break;
                case /* string published_seen_at */ 56:
                    message.publishedSeenAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string assignment_date = 4; */
        if (message.assignmentDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.assignmentDate);
        /* int32 entry_type_id = 5; */
        if (message.entryTypeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.entryTypeId);
        /* int32 role_id = 6; */
        if (message.roleId !== 0)
            writer.tag(6, WireType.Varint).int32(message.roleId);
        /* string on_site_time = 7; */
        if (message.onSiteTime !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.onSiteTime);
        /* string note = 8; */
        if (message.note !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.note);
        /* int32 publish_id = 9; */
        if (message.publishId !== 0)
            writer.tag(9, WireType.Varint).int32(message.publishId);
        /* int32 timeoff_override = 10; */
        if (message.timeoffOverride !== 0)
            writer.tag(10, WireType.Varint).int32(message.timeoffOverride);
        /* string timeoff_override_note = 11; */
        if (message.timeoffOverrideNote !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.timeoffOverrideNote);
        /* int32 is_active = 12; */
        if (message.isActive !== 0)
            writer.tag(12, WireType.Varint).int32(message.isActive);
        /* int32 created_by = 13; */
        if (message.createdBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.createdBy);
        /* string created_at = 14; */
        if (message.createdAt !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 15; */
        if (message.updatedAt !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.updatedAt);
        /* int32 event_id = 16; */
        if (message.eventId !== 0)
            writer.tag(16, WireType.Varint).int32(message.eventId);
        /* int32 shift_type_id = 17; */
        if (message.shiftTypeId !== 0)
            writer.tag(17, WireType.Varint).int32(message.shiftTypeId);
        /* string schedule_on_site_time = 18; */
        if (message.scheduleOnSiteTime !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.scheduleOnSiteTime);
        /* int32 superintendent_user_id = 19; */
        if (message.superintendentUserId !== 0)
            writer.tag(19, WireType.Varint).int32(message.superintendentUserId);
        /* int32 counts_as_booked = 20; */
        if (message.countsAsBooked !== 0)
            writer.tag(20, WireType.Varint).int32(message.countsAsBooked);
        /* string job_number = 21; */
        if (message.jobNumber !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.jobNumber);
        /* string job_name = 22; */
        if (message.jobName !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.jobName);
        /* int32 job_department_id = 23; */
        if (message.jobDepartmentId !== 0)
            writer.tag(23, WireType.Varint).int32(message.jobDepartmentId);
        /* int32 parent_event_id = 24; */
        if (message.parentEventId !== 0)
            writer.tag(24, WireType.Varint).int32(message.parentEventId);
        /* int32 property_id = 25; */
        if (message.propertyId !== 0)
            writer.tag(25, WireType.Varint).int32(message.propertyId);
        /* string property_city = 26; */
        if (message.propertyCity !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.propertyCity);
        /* string user_firstname = 27; */
        if (message.userFirstname !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.userFirstname);
        /* string user_lastname = 28; */
        if (message.userLastname !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.userLastname);
        /* int32 user_department_id = 29; */
        if (message.userDepartmentId !== 0)
            writer.tag(29, WireType.Varint).int32(message.userDepartmentId);
        /* string user_city = 30; */
        if (message.userCity !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.userCity);
        /* int32 timeoff_level = 31; */
        if (message.timeoffLevel !== 0)
            writer.tag(31, WireType.Varint).int32(message.timeoffLevel);
        /* int32 is_draft = 32; */
        if (message.isDraft !== 0)
            writer.tag(32, WireType.Varint).int32(message.isDraft);
        /* int32 pending_removal = 33; */
        if (message.pendingRemoval !== 0)
            writer.tag(33, WireType.Varint).int32(message.pendingRemoval);
        /* int32 published_assignment_id = 34; */
        if (message.publishedAssignmentId !== 0)
            writer.tag(34, WireType.Varint).int32(message.publishedAssignmentId);
        /* int32 published_entry_type_id = 35; */
        if (message.publishedEntryTypeId !== 0)
            writer.tag(35, WireType.Varint).int32(message.publishedEntryTypeId);
        /* int32 published_role_id = 36; */
        if (message.publishedRoleId !== 0)
            writer.tag(36, WireType.Varint).int32(message.publishedRoleId);
        /* string published_on_site_time = 37; */
        if (message.publishedOnSiteTime !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.publishedOnSiteTime);
        /* string published_note = 38; */
        if (message.publishedNote !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.publishedNote);
        /* repeated string date_range = 39; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(39, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 40; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(40, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string user_id_list = 41; */
        if (message.userIdList !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.userIdList);
        /* string schedule_id_list = 42; */
        if (message.scheduleIdList !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.scheduleIdList);
        /* string event_id_list = 43; */
        if (message.eventIdList !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.eventIdList);
        /* string job_department_id_list = 44; */
        if (message.jobDepartmentIdList !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.jobDepartmentIdList);
        /* repeated string field_mask = 45; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(45, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 46; */
        if (message.pageNumber !== 0)
            writer.tag(46, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 47; */
        if (message.orderBy !== "")
            writer.tag(47, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 48; */
        if (message.orderDir !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 49; */
        if (message.withoutLimit !== false)
            writer.tag(49, WireType.Varint).bool(message.withoutLimit);
        /* string end_time = 50; */
        if (message.endTime !== "")
            writer.tag(50, WireType.LengthDelimited).string(message.endTime);
        /* string schedule_end_time = 51; */
        if (message.scheduleEndTime !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.scheduleEndTime);
        /* string published_end_time = 52; */
        if (message.publishedEndTime !== "")
            writer.tag(52, WireType.LengthDelimited).string(message.publishedEndTime);
        /* int32 visit_order = 53; */
        if (message.visitOrder !== 0)
            writer.tag(53, WireType.Varint).int32(message.visitOrder);
        /* int32 published_visit_order = 54; */
        if (message.publishedVisitOrder !== 0)
            writer.tag(54, WireType.Varint).int32(message.publishedVisitOrder);
        /* string seen_at = 55; */
        if (message.seenAt !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.seenAt);
        /* string published_seen_at = 56; */
        if (message.publishedSeenAt !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.publishedSeenAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleAssignmentBoard
 */
export const ScheduleAssignmentBoard = new ScheduleAssignmentBoard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleAssignmentBoardList$Type extends MessageType {
    constructor() {
        super("ScheduleAssignmentBoardList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleAssignmentBoard },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleAssignmentBoard results */ 1:
                    message.results.push(ScheduleAssignmentBoard.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleAssignmentBoard results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleAssignmentBoard.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleAssignmentBoardList
 */
export const ScheduleAssignmentBoardList = new ScheduleAssignmentBoardList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SchedulePublish$Type extends MessageType {
    constructor() {
        super("SchedulePublish", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "filters", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "assignment_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "send_email", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "personal_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "unresolved_conflicts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "schedule_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.note = "";
        message.reason = "";
        message.filters = "";
        message.createdAt = "";
        message.dateRange = [];
        message.dateTarget = [];
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.assignmentIds = [];
        message.sendEmail = false;
        message.personalOnly = false;
        message.unresolvedConflicts = 0;
        message.scheduleIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string note */ 3:
                    message.note = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* string filters */ 5:
                    message.filters = reader.string();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string date_range */ 7:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 8:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                case /* repeated int32 assignment_ids */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.assignmentIds.push(reader.int32());
                    else
                        message.assignmentIds.push(reader.int32());
                    break;
                case /* bool send_email */ 15:
                    message.sendEmail = reader.bool();
                    break;
                case /* bool personal_only */ 16:
                    message.personalOnly = reader.bool();
                    break;
                case /* int32 unresolved_conflicts */ 17:
                    message.unresolvedConflicts = reader.int32();
                    break;
                case /* repeated int32 schedule_ids */ 18:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.scheduleIds.push(reader.int32());
                    else
                        message.scheduleIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string note = 3; */
        if (message.note !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.note);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* string filters = 5; */
        if (message.filters !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.filters);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string date_range = 7; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 8; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        /* repeated int32 assignment_ids = 14; */
        if (message.assignmentIds.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.assignmentIds.length; i++)
                writer.int32(message.assignmentIds[i]);
            writer.join();
        }
        /* bool send_email = 15; */
        if (message.sendEmail !== false)
            writer.tag(15, WireType.Varint).bool(message.sendEmail);
        /* bool personal_only = 16; */
        if (message.personalOnly !== false)
            writer.tag(16, WireType.Varint).bool(message.personalOnly);
        /* int32 unresolved_conflicts = 17; */
        if (message.unresolvedConflicts !== 0)
            writer.tag(17, WireType.Varint).int32(message.unresolvedConflicts);
        /* repeated int32 schedule_ids = 18; */
        if (message.scheduleIds.length) {
            writer.tag(18, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.scheduleIds.length; i++)
                writer.int32(message.scheduleIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SchedulePublish
 */
export const SchedulePublish = new SchedulePublish$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SchedulePublishList$Type extends MessageType {
    constructor() {
        super("SchedulePublishList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SchedulePublish },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SchedulePublish results */ 1:
                    message.results.push(SchedulePublish.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SchedulePublish results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SchedulePublish.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SchedulePublishList
 */
export const SchedulePublishList = new SchedulePublishList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleWeekException$Type extends MessageType {
    constructor() {
        super("ScheduleWeekException", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.weekStart = "";
        message.isActive = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.userIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string week_start */ 3:
                    message.weekStart = reader.string();
                    break;
                case /* int32 is_active */ 4:
                    message.isActive = reader.int32();
                    break;
                case /* int32 created_by */ 5:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* string user_id_list */ 7:
                    message.userIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 10:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 11:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 12:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string week_start = 3; */
        if (message.weekStart !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.weekStart);
        /* int32 is_active = 4; */
        if (message.isActive !== 0)
            writer.tag(4, WireType.Varint).int32(message.isActive);
        /* int32 created_by = 5; */
        if (message.createdBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.createdBy);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* string user_id_list = 7; */
        if (message.userIdList !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userIdList);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 10; */
        if (message.orderBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 11; */
        if (message.orderDir !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 12; */
        if (message.withoutLimit !== false)
            writer.tag(12, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleWeekException
 */
export const ScheduleWeekException = new ScheduleWeekException$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleWeekExceptionList$Type extends MessageType {
    constructor() {
        super("ScheduleWeekExceptionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleWeekException },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleWeekException results */ 1:
                    message.results.push(ScheduleWeekException.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleWeekException results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleWeekException.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleWeekExceptionList
 */
export const ScheduleWeekExceptionList = new ScheduleWeekExceptionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleLodgingLink$Type extends MessageType {
    constructor() {
        super("ScheduleLodgingLink", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "lodging_request_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.scheduleId = 0;
        message.lodgingRequestId = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.scheduleIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* int32 lodging_request_id */ 3:
                    message.lodgingRequestId = reader.int32();
                    break;
                case /* int32 created_by */ 4:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* string schedule_id_list */ 6:
                    message.scheduleIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 9:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 10:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 11:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* int32 lodging_request_id = 3; */
        if (message.lodgingRequestId !== 0)
            writer.tag(3, WireType.Varint).int32(message.lodgingRequestId);
        /* int32 created_by = 4; */
        if (message.createdBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.createdBy);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* string schedule_id_list = 6; */
        if (message.scheduleIdList !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.scheduleIdList);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 9; */
        if (message.orderBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 10; */
        if (message.orderDir !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 11; */
        if (message.withoutLimit !== false)
            writer.tag(11, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleLodgingLink
 */
export const ScheduleLodgingLink = new ScheduleLodgingLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleLodgingLinkList$Type extends MessageType {
    constructor() {
        super("ScheduleLodgingLinkList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleLodgingLink },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleLodgingLink results */ 1:
                    message.results.push(ScheduleLodgingLink.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleLodgingLink results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleLodgingLink.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleLodgingLinkList
 */
export const ScheduleLodgingLinkList = new ScheduleLodgingLinkList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleShiftType$Type extends MessageType {
    constructor() {
        super("ScheduleShiftType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.sortOrder = 0;
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                case /* int32 is_active */ 4:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 7:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 8:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 9:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        /* int32 is_active = 4; */
        if (message.isActive !== 0)
            writer.tag(4, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 7; */
        if (message.orderBy !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 8; */
        if (message.orderDir !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 9; */
        if (message.withoutLimit !== false)
            writer.tag(9, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleShiftType
 */
export const ScheduleShiftType = new ScheduleShiftType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleShiftTypeList$Type extends MessageType {
    constructor() {
        super("ScheduleShiftTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleShiftType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleShiftType results */ 1:
                    message.results.push(ScheduleShiftType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleShiftType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleShiftType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleShiftTypeList
 */
export const ScheduleShiftTypeList = new ScheduleShiftTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleEntryType$Type extends MessageType {
    constructor() {
        super("ScheduleEntryType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "counts_as_booked", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.countsAsBooked = 0;
        message.sortOrder = 0;
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 counts_as_booked */ 3:
                    message.countsAsBooked = reader.int32();
                    break;
                case /* int32 sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* int32 is_active */ 5:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 8:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 9:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 10:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 counts_as_booked = 3; */
        if (message.countsAsBooked !== 0)
            writer.tag(3, WireType.Varint).int32(message.countsAsBooked);
        /* int32 sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* int32 is_active = 5; */
        if (message.isActive !== 0)
            writer.tag(5, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 8; */
        if (message.orderBy !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 9; */
        if (message.orderDir !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 10; */
        if (message.withoutLimit !== false)
            writer.tag(10, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleEntryType
 */
export const ScheduleEntryType = new ScheduleEntryType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleEntryTypeList$Type extends MessageType {
    constructor() {
        super("ScheduleEntryTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleEntryType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleEntryType results */ 1:
                    message.results.push(ScheduleEntryType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleEntryType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleEntryType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleEntryTypeList
 */
export const ScheduleEntryTypeList = new ScheduleEntryTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleAssignmentRole$Type extends MessageType {
    constructor() {
        super("ScheduleAssignmentRole", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.sortOrder = 0;
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                case /* int32 is_active */ 4:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 7:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 8:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 9:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        /* int32 is_active = 4; */
        if (message.isActive !== 0)
            writer.tag(4, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 7; */
        if (message.orderBy !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 8; */
        if (message.orderDir !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 9; */
        if (message.withoutLimit !== false)
            writer.tag(9, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleAssignmentRole
 */
export const ScheduleAssignmentRole = new ScheduleAssignmentRole$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleAssignmentRoleList$Type extends MessageType {
    constructor() {
        super("ScheduleAssignmentRoleList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleAssignmentRole },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleAssignmentRole results */ 1:
                    message.results.push(ScheduleAssignmentRole.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleAssignmentRole results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleAssignmentRole.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleAssignmentRoleList
 */
export const ScheduleAssignmentRoleList = new ScheduleAssignmentRoleList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTimeoffWindow$Type extends MessageType {
    constructor() {
        super("ScheduleTimeoffWindow", [
            { no: 1, name: "timeoff_request_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "request_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "request_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "approval_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "all_day_off", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "include_weekend", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "off_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "off_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "time_finished", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.timeoffRequestId = 0;
        message.userId = 0;
        message.requestTypeId = 0;
        message.requestTypeName = "";
        message.approvalLevel = 0;
        message.allDayOff = 0;
        message.includeWeekend = 0;
        message.offStartDate = "";
        message.offEndDate = "";
        message.timeStarted = "";
        message.timeFinished = "";
        message.dateRange = [];
        message.dateTarget = [];
        message.userIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 timeoff_request_id */ 1:
                    message.timeoffRequestId = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 request_type_id */ 3:
                    message.requestTypeId = reader.int32();
                    break;
                case /* string request_type_name */ 4:
                    message.requestTypeName = reader.string();
                    break;
                case /* int32 approval_level */ 5:
                    message.approvalLevel = reader.int32();
                    break;
                case /* int32 all_day_off */ 6:
                    message.allDayOff = reader.int32();
                    break;
                case /* int32 include_weekend */ 7:
                    message.includeWeekend = reader.int32();
                    break;
                case /* string off_start_date */ 8:
                    message.offStartDate = reader.string();
                    break;
                case /* string off_end_date */ 9:
                    message.offEndDate = reader.string();
                    break;
                case /* string time_started */ 10:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_finished */ 11:
                    message.timeFinished = reader.string();
                    break;
                case /* repeated string date_range */ 12:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 13:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string user_id_list */ 14:
                    message.userIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 15:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 16:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 17:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 18:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 19:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 timeoff_request_id = 1; */
        if (message.timeoffRequestId !== 0)
            writer.tag(1, WireType.Varint).int32(message.timeoffRequestId);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 request_type_id = 3; */
        if (message.requestTypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.requestTypeId);
        /* string request_type_name = 4; */
        if (message.requestTypeName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.requestTypeName);
        /* int32 approval_level = 5; */
        if (message.approvalLevel !== 0)
            writer.tag(5, WireType.Varint).int32(message.approvalLevel);
        /* int32 all_day_off = 6; */
        if (message.allDayOff !== 0)
            writer.tag(6, WireType.Varint).int32(message.allDayOff);
        /* int32 include_weekend = 7; */
        if (message.includeWeekend !== 0)
            writer.tag(7, WireType.Varint).int32(message.includeWeekend);
        /* string off_start_date = 8; */
        if (message.offStartDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.offStartDate);
        /* string off_end_date = 9; */
        if (message.offEndDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.offEndDate);
        /* string time_started = 10; */
        if (message.timeStarted !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_finished = 11; */
        if (message.timeFinished !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.timeFinished);
        /* repeated string date_range = 12; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 13; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string user_id_list = 14; */
        if (message.userIdList !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.userIdList);
        /* repeated string field_mask = 15; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 16; */
        if (message.pageNumber !== 0)
            writer.tag(16, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 17; */
        if (message.orderBy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 18; */
        if (message.orderDir !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 19; */
        if (message.withoutLimit !== false)
            writer.tag(19, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTimeoffWindow
 */
export const ScheduleTimeoffWindow = new ScheduleTimeoffWindow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTimeoffWindowList$Type extends MessageType {
    constructor() {
        super("ScheduleTimeoffWindowList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTimeoffWindow },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTimeoffWindow results */ 1:
                    message.results.push(ScheduleTimeoffWindow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTimeoffWindow results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleTimeoffWindow.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTimeoffWindowList
 */
export const ScheduleTimeoffWindowList = new ScheduleTimeoffWindowList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleEmailRequest$Type extends MessageType {
    constructor() {
        super("ScheduleEmailRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "publish_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.departmentId = 0;
        message.weekStart = "";
        message.publishId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* string week_start */ 3:
                    message.weekStart = reader.string();
                    break;
                case /* int32 publish_id */ 4:
                    message.publishId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* string week_start = 3; */
        if (message.weekStart !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.weekStart);
        /* int32 publish_id = 4; */
        if (message.publishId !== 0)
            writer.tag(4, WireType.Varint).int32(message.publishId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleEmailRequest
 */
export const ScheduleEmailRequest = new ScheduleEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleEmail$Type extends MessageType {
    constructor() {
        super("ScheduleEmail", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "html", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cc", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "recipient_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "changed_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subject = "";
        message.html = "";
        message.to = "";
        message.cc = [];
        message.recipientUserId = 0;
        message.departmentId = 0;
        message.changedCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject */ 1:
                    message.subject = reader.string();
                    break;
                case /* string html */ 2:
                    message.html = reader.string();
                    break;
                case /* string to */ 3:
                    message.to = reader.string();
                    break;
                case /* repeated string cc */ 4:
                    message.cc.push(reader.string());
                    break;
                case /* int32 recipient_user_id */ 5:
                    message.recipientUserId = reader.int32();
                    break;
                case /* int32 department_id */ 6:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 changed_count */ 7:
                    message.changedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string subject = 1; */
        if (message.subject !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subject);
        /* string html = 2; */
        if (message.html !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.html);
        /* string to = 3; */
        if (message.to !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.to);
        /* repeated string cc = 4; */
        for (let i = 0; i < message.cc.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.cc[i]);
        /* int32 recipient_user_id = 5; */
        if (message.recipientUserId !== 0)
            writer.tag(5, WireType.Varint).int32(message.recipientUserId);
        /* int32 department_id = 6; */
        if (message.departmentId !== 0)
            writer.tag(6, WireType.Varint).int32(message.departmentId);
        /* int32 changed_count = 7; */
        if (message.changedCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.changedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleEmail
 */
export const ScheduleEmail = new ScheduleEmail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleEmailSendLine$Type extends MessageType {
    constructor() {
        super("ScheduleEmailSendLine", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.departmentId = 0;
        message.to = "";
        message.status = "";
        message.detail = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* string to */ 3:
                    message.to = reader.string();
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                case /* string detail */ 5:
                    message.detail = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* string to = 3; */
        if (message.to !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.to);
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        /* string detail = 5; */
        if (message.detail !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.detail);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleEmailSendLine
 */
export const ScheduleEmailSendLine = new ScheduleEmailSendLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleEmailSendResult$Type extends MessageType {
    constructor() {
        super("ScheduleEmailSendResult", [
            { no: 1, name: "publish_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "failed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleEmailSendLine }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.publishId = 0;
        message.sent = 0;
        message.skipped = 0;
        message.failed = 0;
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 publish_id */ 1:
                    message.publishId = reader.int32();
                    break;
                case /* int32 sent */ 2:
                    message.sent = reader.int32();
                    break;
                case /* int32 skipped */ 3:
                    message.skipped = reader.int32();
                    break;
                case /* int32 failed */ 4:
                    message.failed = reader.int32();
                    break;
                case /* repeated ScheduleEmailSendLine results */ 5:
                    message.results.push(ScheduleEmailSendLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 publish_id = 1; */
        if (message.publishId !== 0)
            writer.tag(1, WireType.Varint).int32(message.publishId);
        /* int32 sent = 2; */
        if (message.sent !== 0)
            writer.tag(2, WireType.Varint).int32(message.sent);
        /* int32 skipped = 3; */
        if (message.skipped !== 0)
            writer.tag(3, WireType.Varint).int32(message.skipped);
        /* int32 failed = 4; */
        if (message.failed !== 0)
            writer.tag(4, WireType.Varint).int32(message.failed);
        /* repeated ScheduleEmailSendLine results = 5; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleEmailSendLine.internalBinaryWrite(message.results[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleEmailSendResult
 */
export const ScheduleEmailSendResult = new ScheduleEmailSendResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleLookaheadRequest$Type extends MessageType {
    constructor() {
        super("ScheduleLookaheadRequest", [
            { no: 1, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "department_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "as_pdf", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.weekStart = "";
        message.departmentIdList = "";
        message.asPdf = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string week_start */ 1:
                    message.weekStart = reader.string();
                    break;
                case /* string department_id_list */ 2:
                    message.departmentIdList = reader.string();
                    break;
                case /* bool as_pdf */ 3:
                    message.asPdf = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string week_start = 1; */
        if (message.weekStart !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.weekStart);
        /* string department_id_list = 2; */
        if (message.departmentIdList !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentIdList);
        /* bool as_pdf = 3; */
        if (message.asPdf !== false)
            writer.tag(3, WireType.Varint).bool(message.asPdf);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleLookaheadRequest
 */
export const ScheduleLookaheadRequest = new ScheduleLookaheadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleLookahead$Type extends MessageType {
    constructor() {
        super("ScheduleLookahead", [
            { no: 1, name: "html", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pdf_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "draft_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.html = "";
        message.pdfUrl = "";
        message.draftCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string html */ 1:
                    message.html = reader.string();
                    break;
                case /* string pdf_url */ 2:
                    message.pdfUrl = reader.string();
                    break;
                case /* int32 draft_count */ 3:
                    message.draftCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string html = 1; */
        if (message.html !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.html);
        /* string pdf_url = 2; */
        if (message.pdfUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pdfUrl);
        /* int32 draft_count = 3; */
        if (message.draftCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.draftCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleLookahead
 */
export const ScheduleLookahead = new ScheduleLookahead$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SchedulePerDiemLink$Type extends MessageType {
    constructor() {
        super("SchedulePerDiemLink", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "per_diem_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.scheduleId = 0;
        message.perDiemId = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.scheduleIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* int32 per_diem_id */ 3:
                    message.perDiemId = reader.int32();
                    break;
                case /* int32 created_by */ 4:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* string schedule_id_list */ 6:
                    message.scheduleIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 9:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 10:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 11:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* int32 per_diem_id = 3; */
        if (message.perDiemId !== 0)
            writer.tag(3, WireType.Varint).int32(message.perDiemId);
        /* int32 created_by = 4; */
        if (message.createdBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.createdBy);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* string schedule_id_list = 6; */
        if (message.scheduleIdList !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.scheduleIdList);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 9; */
        if (message.orderBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 10; */
        if (message.orderDir !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 11; */
        if (message.withoutLimit !== false)
            writer.tag(11, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SchedulePerDiemLink
 */
export const SchedulePerDiemLink = new SchedulePerDiemLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SchedulePerDiemLinkList$Type extends MessageType {
    constructor() {
        super("SchedulePerDiemLinkList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SchedulePerDiemLink },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SchedulePerDiemLink results */ 1:
                    message.results.push(SchedulePerDiemLink.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SchedulePerDiemLink results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SchedulePerDiemLink.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SchedulePerDiemLinkList
 */
export const SchedulePerDiemLinkList = new SchedulePerDiemLinkList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelRequest$Type extends MessageType {
    constructor() {
        super("ScheduleTravelRequest", [
            { no: 1, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "preview", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "omit_keys", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.weekStart = "";
        message.scheduleIdList = "";
        message.userId = 0;
        message.preview = false;
        message.omitKeys = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string week_start */ 1:
                    message.weekStart = reader.string();
                    break;
                case /* string schedule_id_list */ 2:
                    message.scheduleIdList = reader.string();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* bool preview */ 4:
                    message.preview = reader.bool();
                    break;
                case /* repeated string omit_keys */ 5:
                    message.omitKeys.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string week_start = 1; */
        if (message.weekStart !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.weekStart);
        /* string schedule_id_list = 2; */
        if (message.scheduleIdList !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.scheduleIdList);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* bool preview = 4; */
        if (message.preview !== false)
            writer.tag(4, WireType.Varint).bool(message.preview);
        /* repeated string omit_keys = 5; */
        for (let i = 0; i < message.omitKeys.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.omitKeys[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelRequest
 */
export const ScheduleTravelRequest = new ScheduleTravelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelLine$Type extends MessageType {
    constructor() {
        super("ScheduleTravelLine", [
            { no: 1, name: "kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "record_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "date_from", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "date_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "dates", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "optional", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = "";
        message.scheduleId = 0;
        message.userId = 0;
        message.recordId = 0;
        message.status = "";
        message.detail = "";
        message.userIdList = "";
        message.dateFrom = "";
        message.dateTo = "";
        message.dates = [];
        message.key = "";
        message.optional = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string kind */ 1:
                    message.kind = reader.string();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* int32 record_id */ 4:
                    message.recordId = reader.int32();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                case /* string detail */ 6:
                    message.detail = reader.string();
                    break;
                case /* string user_id_list */ 7:
                    message.userIdList = reader.string();
                    break;
                case /* string date_from */ 8:
                    message.dateFrom = reader.string();
                    break;
                case /* string date_to */ 9:
                    message.dateTo = reader.string();
                    break;
                case /* repeated string dates */ 10:
                    message.dates.push(reader.string());
                    break;
                case /* string key */ 11:
                    message.key = reader.string();
                    break;
                case /* bool optional */ 12:
                    message.optional = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string kind = 1; */
        if (message.kind !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.kind);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* int32 record_id = 4; */
        if (message.recordId !== 0)
            writer.tag(4, WireType.Varint).int32(message.recordId);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        /* string detail = 6; */
        if (message.detail !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.detail);
        /* string user_id_list = 7; */
        if (message.userIdList !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userIdList);
        /* string date_from = 8; */
        if (message.dateFrom !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.dateFrom);
        /* string date_to = 9; */
        if (message.dateTo !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.dateTo);
        /* repeated string dates = 10; */
        for (let i = 0; i < message.dates.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.dates[i]);
        /* string key = 11; */
        if (message.key !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.key);
        /* bool optional = 12; */
        if (message.optional !== false)
            writer.tag(12, WireType.Varint).bool(message.optional);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelLine
 */
export const ScheduleTravelLine = new ScheduleTravelLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelResult$Type extends MessageType {
    constructor() {
        super("ScheduleTravelResult", [
            { no: 1, name: "lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTravelLine },
            { no: 2, name: "created", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "updated", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "stale", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "preview", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "linked", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "proposed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "errors", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.lines = [];
        message.created = 0;
        message.updated = 0;
        message.skipped = 0;
        message.stale = 0;
        message.preview = false;
        message.linked = 0;
        message.proposed = 0;
        message.errors = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTravelLine lines */ 1:
                    message.lines.push(ScheduleTravelLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 created */ 2:
                    message.created = reader.int32();
                    break;
                case /* int32 updated */ 3:
                    message.updated = reader.int32();
                    break;
                case /* int32 skipped */ 4:
                    message.skipped = reader.int32();
                    break;
                case /* int32 stale */ 5:
                    message.stale = reader.int32();
                    break;
                case /* bool preview */ 6:
                    message.preview = reader.bool();
                    break;
                case /* int32 linked */ 7:
                    message.linked = reader.int32();
                    break;
                case /* int32 proposed */ 8:
                    message.proposed = reader.int32();
                    break;
                case /* int32 errors */ 9:
                    message.errors = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTravelLine lines = 1; */
        for (let i = 0; i < message.lines.length; i++)
            ScheduleTravelLine.internalBinaryWrite(message.lines[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 created = 2; */
        if (message.created !== 0)
            writer.tag(2, WireType.Varint).int32(message.created);
        /* int32 updated = 3; */
        if (message.updated !== 0)
            writer.tag(3, WireType.Varint).int32(message.updated);
        /* int32 skipped = 4; */
        if (message.skipped !== 0)
            writer.tag(4, WireType.Varint).int32(message.skipped);
        /* int32 stale = 5; */
        if (message.stale !== 0)
            writer.tag(5, WireType.Varint).int32(message.stale);
        /* bool preview = 6; */
        if (message.preview !== false)
            writer.tag(6, WireType.Varint).bool(message.preview);
        /* int32 linked = 7; */
        if (message.linked !== 0)
            writer.tag(7, WireType.Varint).int32(message.linked);
        /* int32 proposed = 8; */
        if (message.proposed !== 0)
            writer.tag(8, WireType.Varint).int32(message.proposed);
        /* int32 errors = 9; */
        if (message.errors !== 0)
            writer.tag(9, WireType.Varint).int32(message.errors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelResult
 */
export const ScheduleTravelResult = new ScheduleTravelResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelTierRequest$Type extends MessageType {
    constructor() {
        super("ScheduleTravelTierRequest", [
            { no: 1, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.weekStart = "";
        message.scheduleIdList = "";
        message.userIdList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string week_start */ 1:
                    message.weekStart = reader.string();
                    break;
                case /* string schedule_id_list */ 2:
                    message.scheduleIdList = reader.string();
                    break;
                case /* string user_id_list */ 3:
                    message.userIdList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string week_start = 1; */
        if (message.weekStart !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.weekStart);
        /* string schedule_id_list = 2; */
        if (message.scheduleIdList !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.scheduleIdList);
        /* string user_id_list = 3; */
        if (message.userIdList !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userIdList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelTierRequest
 */
export const ScheduleTravelTierRequest = new ScheduleTravelTierRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelTier$Type extends MessageType {
    constructor() {
        super("ScheduleTravelTier", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "tier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "duration_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.eventId = 0;
        message.scheduleId = 0;
        message.tier = "";
        message.durationSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 schedule_id */ 3:
                    message.scheduleId = reader.int32();
                    break;
                case /* string tier */ 4:
                    message.tier = reader.string();
                    break;
                case /* int32 duration_seconds */ 5:
                    message.durationSeconds = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 schedule_id = 3; */
        if (message.scheduleId !== 0)
            writer.tag(3, WireType.Varint).int32(message.scheduleId);
        /* string tier = 4; */
        if (message.tier !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tier);
        /* int32 duration_seconds = 5; */
        if (message.durationSeconds !== 0)
            writer.tag(5, WireType.Varint).int32(message.durationSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelTier
 */
export const ScheduleTravelTier = new ScheduleTravelTier$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelTierList$Type extends MessageType {
    constructor() {
        super("ScheduleTravelTierList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTravelTier },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTravelTier results */ 1:
                    message.results.push(ScheduleTravelTier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTravelTier results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleTravelTier.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelTierList
 */
export const ScheduleTravelTierList = new ScheduleTravelTierList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleLodgingExclusion$Type extends MessageType {
    constructor() {
        super("ScheduleLodgingExclusion", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "lodging_request_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "lodging_request_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.lodgingRequestId = 0;
        message.userId = 0;
        message.reason = "";
        message.createdBy = 0;
        message.createdAt = "";
        message.isActive = 0;
        message.lodgingRequestIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 lodging_request_id */ 2:
                    message.lodgingRequestId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* int32 created_by */ 5:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* int32 is_active */ 7:
                    message.isActive = reader.int32();
                    break;
                case /* string lodging_request_id_list */ 8:
                    message.lodgingRequestIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 lodging_request_id = 2; */
        if (message.lodgingRequestId !== 0)
            writer.tag(2, WireType.Varint).int32(message.lodgingRequestId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* int32 created_by = 5; */
        if (message.createdBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.createdBy);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* int32 is_active = 7; */
        if (message.isActive !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActive);
        /* string lodging_request_id_list = 8; */
        if (message.lodgingRequestIdList !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.lodgingRequestIdList);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleLodgingExclusion
 */
export const ScheduleLodgingExclusion = new ScheduleLodgingExclusion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleLodgingExclusionList$Type extends MessageType {
    constructor() {
        super("ScheduleLodgingExclusionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleLodgingExclusion },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleLodgingExclusion results */ 1:
                    message.results.push(ScheduleLodgingExclusion.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleLodgingExclusion results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleLodgingExclusion.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleLodgingExclusionList
 */
export const ScheduleLodgingExclusionList = new ScheduleLodgingExclusionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleConflictType$Type extends MessageType {
    constructor() {
        super("ScheduleConflictType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated string field_mask */ 3:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 4:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 5:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 6:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 7:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated string field_mask = 3; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 4; */
        if (message.pageNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 5; */
        if (message.orderBy !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 6; */
        if (message.orderDir !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 7; */
        if (message.withoutLimit !== false)
            writer.tag(7, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleConflictType
 */
export const ScheduleConflictType = new ScheduleConflictType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleConflictTypeList$Type extends MessageType {
    constructor() {
        super("ScheduleConflictTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleConflictType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleConflictType results */ 1:
                    message.results.push(ScheduleConflictType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleConflictType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleConflictType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleConflictTypeList
 */
export const ScheduleConflictTypeList = new ScheduleConflictTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleConflictResolution$Type extends MessageType {
    constructor() {
        super("ScheduleConflictResolution", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "conflict_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "conflict_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "conditions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "resolved_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "resolved_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "reopened_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "conflict_type_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.conflictTypeId = 0;
        message.weekStart = "";
        message.userId = 0;
        message.scheduleId = 0;
        message.conflictDate = "";
        message.conditions = "";
        message.note = "";
        message.resolvedBy = 0;
        message.resolvedAt = "";
        message.reopenedAt = "";
        message.isActive = 0;
        message.conflictTypeIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 conflict_type_id */ 2:
                    message.conflictTypeId = reader.int32();
                    break;
                case /* string week_start */ 3:
                    message.weekStart = reader.string();
                    break;
                case /* int32 user_id */ 4:
                    message.userId = reader.int32();
                    break;
                case /* int32 schedule_id */ 5:
                    message.scheduleId = reader.int32();
                    break;
                case /* string conflict_date */ 6:
                    message.conflictDate = reader.string();
                    break;
                case /* string conditions */ 7:
                    message.conditions = reader.string();
                    break;
                case /* string note */ 8:
                    message.note = reader.string();
                    break;
                case /* int32 resolved_by */ 9:
                    message.resolvedBy = reader.int32();
                    break;
                case /* string resolved_at */ 10:
                    message.resolvedAt = reader.string();
                    break;
                case /* string reopened_at */ 11:
                    message.reopenedAt = reader.string();
                    break;
                case /* int32 is_active */ 12:
                    message.isActive = reader.int32();
                    break;
                case /* string conflict_type_id_list */ 13:
                    message.conflictTypeIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 14:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 15:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 16:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 17:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 18:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 conflict_type_id = 2; */
        if (message.conflictTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.conflictTypeId);
        /* string week_start = 3; */
        if (message.weekStart !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.weekStart);
        /* int32 user_id = 4; */
        if (message.userId !== 0)
            writer.tag(4, WireType.Varint).int32(message.userId);
        /* int32 schedule_id = 5; */
        if (message.scheduleId !== 0)
            writer.tag(5, WireType.Varint).int32(message.scheduleId);
        /* string conflict_date = 6; */
        if (message.conflictDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.conflictDate);
        /* string conditions = 7; */
        if (message.conditions !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.conditions);
        /* string note = 8; */
        if (message.note !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.note);
        /* int32 resolved_by = 9; */
        if (message.resolvedBy !== 0)
            writer.tag(9, WireType.Varint).int32(message.resolvedBy);
        /* string resolved_at = 10; */
        if (message.resolvedAt !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.resolvedAt);
        /* string reopened_at = 11; */
        if (message.reopenedAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.reopenedAt);
        /* int32 is_active = 12; */
        if (message.isActive !== 0)
            writer.tag(12, WireType.Varint).int32(message.isActive);
        /* string conflict_type_id_list = 13; */
        if (message.conflictTypeIdList !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.conflictTypeIdList);
        /* repeated string field_mask = 14; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 15; */
        if (message.pageNumber !== 0)
            writer.tag(15, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 16; */
        if (message.orderBy !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 17; */
        if (message.orderDir !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 18; */
        if (message.withoutLimit !== false)
            writer.tag(18, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleConflictResolution
 */
export const ScheduleConflictResolution = new ScheduleConflictResolution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleConflictResolutionList$Type extends MessageType {
    constructor() {
        super("ScheduleConflictResolutionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleConflictResolution },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleConflictResolution results */ 1:
                    message.results.push(ScheduleConflictResolution.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleConflictResolution results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleConflictResolution.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleConflictResolutionList
 */
export const ScheduleConflictResolutionList = new ScheduleConflictResolutionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTradeRequest$Type extends MessageType {
    constructor() {
        super("ScheduleTradeRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "assignment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "department_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.scheduleId = 0;
        message.assignmentDate = "";
        message.departmentId = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.isActive = 0;
        message.scheduleIdList = "";
        message.departmentIdList = "";
        message.dateRange = [];
        message.dateTarget = [];
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 schedule_id */ 2:
                    message.scheduleId = reader.int32();
                    break;
                case /* string assignment_date */ 3:
                    message.assignmentDate = reader.string();
                    break;
                case /* int32 department_id */ 4:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 created_by */ 5:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* int32 is_active */ 7:
                    message.isActive = reader.int32();
                    break;
                case /* string schedule_id_list */ 8:
                    message.scheduleIdList = reader.string();
                    break;
                case /* string department_id_list */ 9:
                    message.departmentIdList = reader.string();
                    break;
                case /* repeated string date_range */ 10:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 11:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string field_mask */ 12:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 13:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 14:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 15:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 16:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 schedule_id = 2; */
        if (message.scheduleId !== 0)
            writer.tag(2, WireType.Varint).int32(message.scheduleId);
        /* string assignment_date = 3; */
        if (message.assignmentDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.assignmentDate);
        /* int32 department_id = 4; */
        if (message.departmentId !== 0)
            writer.tag(4, WireType.Varint).int32(message.departmentId);
        /* int32 created_by = 5; */
        if (message.createdBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.createdBy);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* int32 is_active = 7; */
        if (message.isActive !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActive);
        /* string schedule_id_list = 8; */
        if (message.scheduleIdList !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.scheduleIdList);
        /* string department_id_list = 9; */
        if (message.departmentIdList !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.departmentIdList);
        /* repeated string date_range = 10; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 11; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string field_mask = 12; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 13; */
        if (message.pageNumber !== 0)
            writer.tag(13, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 14; */
        if (message.orderBy !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 15; */
        if (message.orderDir !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 16; */
        if (message.withoutLimit !== false)
            writer.tag(16, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTradeRequest
 */
export const ScheduleTradeRequest = new ScheduleTradeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTradeRequestList$Type extends MessageType {
    constructor() {
        super("ScheduleTradeRequestList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTradeRequest },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTradeRequest results */ 1:
                    message.results.push(ScheduleTradeRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTradeRequest results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleTradeRequest.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTradeRequestList
 */
export const ScheduleTradeRequestList = new ScheduleTradeRequestList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTeam$Type extends MessageType {
    constructor() {
        super("ScheduleTeam", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lead_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.leadUserId = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* int32 lead_user_id */ 4:
                    message.leadUserId = reader.int32();
                    break;
                case /* int32 created_by */ 5:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* int32 is_active */ 7:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* int32 lead_user_id = 4; */
        if (message.leadUserId !== 0)
            writer.tag(4, WireType.Varint).int32(message.leadUserId);
        /* int32 created_by = 5; */
        if (message.createdBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.createdBy);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* int32 is_active = 7; */
        if (message.isActive !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTeam
 */
export const ScheduleTeam = new ScheduleTeam$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTeamList$Type extends MessageType {
    constructor() {
        super("ScheduleTeamList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTeam },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTeam results */ 1:
                    message.results.push(ScheduleTeam.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTeam results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleTeam.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTeamList
 */
export const ScheduleTeamList = new ScheduleTeamList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTeamMember$Type extends MessageType {
    constructor() {
        super("ScheduleTeamMember", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "team_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "team_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.teamId = 0;
        message.userId = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.isActive = 0;
        message.teamIdList = "";
        message.userIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 team_id */ 2:
                    message.teamId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* int32 created_by */ 4:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* int32 is_active */ 6:
                    message.isActive = reader.int32();
                    break;
                case /* string team_id_list */ 7:
                    message.teamIdList = reader.string();
                    break;
                case /* string user_id_list */ 8:
                    message.userIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 team_id = 2; */
        if (message.teamId !== 0)
            writer.tag(2, WireType.Varint).int32(message.teamId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* int32 created_by = 4; */
        if (message.createdBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.createdBy);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* int32 is_active = 6; */
        if (message.isActive !== 0)
            writer.tag(6, WireType.Varint).int32(message.isActive);
        /* string team_id_list = 7; */
        if (message.teamIdList !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.teamIdList);
        /* string user_id_list = 8; */
        if (message.userIdList !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.userIdList);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTeamMember
 */
export const ScheduleTeamMember = new ScheduleTeamMember$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTeamMemberList$Type extends MessageType {
    constructor() {
        super("ScheduleTeamMemberList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTeamMember },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTeamMember results */ 1:
                    message.results.push(ScheduleTeamMember.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTeamMember results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleTeamMember.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTeamMemberList
 */
export const ScheduleTeamMemberList = new ScheduleTeamMemberList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleActivityType$Type extends MessageType {
    constructor() {
        super("ScheduleActivityType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated string field_mask */ 3:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 4:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 5:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 6:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 7:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated string field_mask = 3; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 4; */
        if (message.pageNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 5; */
        if (message.orderBy !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 6; */
        if (message.orderDir !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 7; */
        if (message.withoutLimit !== false)
            writer.tag(7, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleActivityType
 */
export const ScheduleActivityType = new ScheduleActivityType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleActivityTypeList$Type extends MessageType {
    constructor() {
        super("ScheduleActivityTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleActivityType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleActivityType results */ 1:
                    message.results.push(ScheduleActivityType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleActivityType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleActivityType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleActivityTypeList
 */
export const ScheduleActivityTypeList = new ScheduleActivityTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleActivityLog$Type extends MessageType {
    constructor() {
        super("ScheduleActivityLog", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "activity_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "schedule_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "schedule_assignment_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "assignment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "week_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "publish_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "changes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "schedule_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.activityTypeId = 0;
        message.scheduleId = 0;
        message.scheduleAssignmentId = 0;
        message.eventId = 0;
        message.userId = 0;
        message.assignmentDate = "";
        message.weekStart = "";
        message.publishId = 0;
        message.changes = "";
        message.description = "";
        message.createdBy = 0;
        message.createdAt = "";
        message.scheduleIdList = "";
        message.userIdList = "";
        message.dateRange = [];
        message.dateTarget = [];
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 activity_type_id */ 2:
                    message.activityTypeId = reader.int32();
                    break;
                case /* int32 schedule_id */ 3:
                    message.scheduleId = reader.int32();
                    break;
                case /* int32 schedule_assignment_id */ 4:
                    message.scheduleAssignmentId = reader.int32();
                    break;
                case /* int32 event_id */ 5:
                    message.eventId = reader.int32();
                    break;
                case /* int32 user_id */ 6:
                    message.userId = reader.int32();
                    break;
                case /* string assignment_date */ 7:
                    message.assignmentDate = reader.string();
                    break;
                case /* string week_start */ 8:
                    message.weekStart = reader.string();
                    break;
                case /* int32 publish_id */ 9:
                    message.publishId = reader.int32();
                    break;
                case /* string changes */ 10:
                    message.changes = reader.string();
                    break;
                case /* string description */ 11:
                    message.description = reader.string();
                    break;
                case /* int32 created_by */ 12:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 13:
                    message.createdAt = reader.string();
                    break;
                case /* string schedule_id_list */ 14:
                    message.scheduleIdList = reader.string();
                    break;
                case /* string user_id_list */ 15:
                    message.userIdList = reader.string();
                    break;
                case /* repeated string date_range */ 16:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 17:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string field_mask */ 18:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 19:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 20:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 21:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 22:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 activity_type_id = 2; */
        if (message.activityTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.activityTypeId);
        /* int32 schedule_id = 3; */
        if (message.scheduleId !== 0)
            writer.tag(3, WireType.Varint).int32(message.scheduleId);
        /* int32 schedule_assignment_id = 4; */
        if (message.scheduleAssignmentId !== 0)
            writer.tag(4, WireType.Varint).int32(message.scheduleAssignmentId);
        /* int32 event_id = 5; */
        if (message.eventId !== 0)
            writer.tag(5, WireType.Varint).int32(message.eventId);
        /* int32 user_id = 6; */
        if (message.userId !== 0)
            writer.tag(6, WireType.Varint).int32(message.userId);
        /* string assignment_date = 7; */
        if (message.assignmentDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.assignmentDate);
        /* string week_start = 8; */
        if (message.weekStart !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.weekStart);
        /* int32 publish_id = 9; */
        if (message.publishId !== 0)
            writer.tag(9, WireType.Varint).int32(message.publishId);
        /* string changes = 10; */
        if (message.changes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.changes);
        /* string description = 11; */
        if (message.description !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.description);
        /* int32 created_by = 12; */
        if (message.createdBy !== 0)
            writer.tag(12, WireType.Varint).int32(message.createdBy);
        /* string created_at = 13; */
        if (message.createdAt !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.createdAt);
        /* string schedule_id_list = 14; */
        if (message.scheduleIdList !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.scheduleIdList);
        /* string user_id_list = 15; */
        if (message.userIdList !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.userIdList);
        /* repeated string date_range = 16; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 17; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(17, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string field_mask = 18; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(18, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 19; */
        if (message.pageNumber !== 0)
            writer.tag(19, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 20; */
        if (message.orderBy !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 21; */
        if (message.orderDir !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 22; */
        if (message.withoutLimit !== false)
            writer.tag(22, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleActivityLog
 */
export const ScheduleActivityLog = new ScheduleActivityLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleActivityLogList$Type extends MessageType {
    constructor() {
        super("ScheduleActivityLogList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleActivityLog },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleActivityLog results */ 1:
                    message.results.push(ScheduleActivityLog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleActivityLog results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleActivityLog.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleActivityLogList
 */
export const ScheduleActivityLogList = new ScheduleActivityLogList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelDay$Type extends MessageType {
    constructor() {
        super("ScheduleTravelDay", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "travel_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lodging_request_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "lodging_assignment_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "lodging_requestor_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "lodging_job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "check_in_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "check_out_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "lodging_status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "lodging_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "lodging_admin_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "lodging_internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "lodging_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "lodging_per_diem_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "lodging_assignment_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "lodging_assignment_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "per_diem_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "per_diem_row_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "per_diem_date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "per_diem_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "per_diem_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "per_diem_date_submitted", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "per_diem_date_approved", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "per_diem_approved_by_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "per_diem_needs_auditing", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "payroll_processed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "per_diem_date_processed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "per_diem_amount_processed_lodging", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "per_diem_amount_processed_meals", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "per_diem_ignore_first_day_deduction", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "per_diem_ignore_last_day_deduction", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "per_diem_row_zip_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "per_diem_row_service_call_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "per_diem_row_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "per_diem_row_meals_only", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 36, name: "per_diem_row_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "per_diem_row_needs_auditing", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 38, name: "per_diem_row_lodging_request_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 39, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 44, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.travelDate = "";
        message.lodgingRequestId = 0;
        message.lodgingAssignmentId = 0;
        message.lodgingRequestorId = 0;
        message.lodgingJobId = 0;
        message.checkInDate = "";
        message.checkOutDate = "";
        message.lodgingStatusId = 0;
        message.lodgingNotes = "";
        message.lodgingAdminNotes = "";
        message.lodgingInternalNotes = "";
        message.lodgingAddress = "";
        message.lodgingPerDiemType = 0;
        message.lodgingAssignmentNotes = "";
        message.lodgingAssignmentCost = 0;
        message.perDiemId = 0;
        message.perDiemRowId = 0;
        message.perDiemDateStarted = "";
        message.perDiemDepartmentId = 0;
        message.perDiemNotes = "";
        message.perDiemDateSubmitted = "";
        message.perDiemDateApproved = "";
        message.perDiemApprovedById = 0;
        message.perDiemNeedsAuditing = 0;
        message.payrollProcessed = 0;
        message.perDiemDateProcessed = "";
        message.perDiemAmountProcessedLodging = "";
        message.perDiemAmountProcessedMeals = "";
        message.perDiemIgnoreFirstDayDeduction = 0;
        message.perDiemIgnoreLastDayDeduction = 0;
        message.perDiemRowZipCode = "";
        message.perDiemRowServiceCallId = 0;
        message.perDiemRowNotes = "";
        message.perDiemRowMealsOnly = 0;
        message.perDiemRowDate = "";
        message.perDiemRowNeedsAuditing = 0;
        message.perDiemRowLodgingRequestId = 0;
        message.dateRange = [];
        message.dateTarget = [];
        message.userIdList = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string travel_date */ 2:
                    message.travelDate = reader.string();
                    break;
                case /* int32 lodging_request_id */ 3:
                    message.lodgingRequestId = reader.int32();
                    break;
                case /* int32 lodging_assignment_id */ 4:
                    message.lodgingAssignmentId = reader.int32();
                    break;
                case /* int32 lodging_requestor_id */ 5:
                    message.lodgingRequestorId = reader.int32();
                    break;
                case /* int32 lodging_job_id */ 6:
                    message.lodgingJobId = reader.int32();
                    break;
                case /* string check_in_date */ 7:
                    message.checkInDate = reader.string();
                    break;
                case /* string check_out_date */ 8:
                    message.checkOutDate = reader.string();
                    break;
                case /* int32 lodging_status_id */ 9:
                    message.lodgingStatusId = reader.int32();
                    break;
                case /* string lodging_notes */ 10:
                    message.lodgingNotes = reader.string();
                    break;
                case /* string lodging_admin_notes */ 11:
                    message.lodgingAdminNotes = reader.string();
                    break;
                case /* string lodging_internal_notes */ 12:
                    message.lodgingInternalNotes = reader.string();
                    break;
                case /* string lodging_address */ 13:
                    message.lodgingAddress = reader.string();
                    break;
                case /* int32 lodging_per_diem_type */ 14:
                    message.lodgingPerDiemType = reader.int32();
                    break;
                case /* string lodging_assignment_notes */ 15:
                    message.lodgingAssignmentNotes = reader.string();
                    break;
                case /* double lodging_assignment_cost */ 16:
                    message.lodgingAssignmentCost = reader.double();
                    break;
                case /* int32 per_diem_id */ 17:
                    message.perDiemId = reader.int32();
                    break;
                case /* int32 per_diem_row_id */ 18:
                    message.perDiemRowId = reader.int32();
                    break;
                case /* string per_diem_date_started */ 19:
                    message.perDiemDateStarted = reader.string();
                    break;
                case /* int32 per_diem_department_id */ 20:
                    message.perDiemDepartmentId = reader.int32();
                    break;
                case /* string per_diem_notes */ 21:
                    message.perDiemNotes = reader.string();
                    break;
                case /* string per_diem_date_submitted */ 22:
                    message.perDiemDateSubmitted = reader.string();
                    break;
                case /* string per_diem_date_approved */ 23:
                    message.perDiemDateApproved = reader.string();
                    break;
                case /* int32 per_diem_approved_by_id */ 24:
                    message.perDiemApprovedById = reader.int32();
                    break;
                case /* int32 per_diem_needs_auditing */ 25:
                    message.perDiemNeedsAuditing = reader.int32();
                    break;
                case /* int32 payroll_processed */ 26:
                    message.payrollProcessed = reader.int32();
                    break;
                case /* string per_diem_date_processed */ 27:
                    message.perDiemDateProcessed = reader.string();
                    break;
                case /* string per_diem_amount_processed_lodging */ 28:
                    message.perDiemAmountProcessedLodging = reader.string();
                    break;
                case /* string per_diem_amount_processed_meals */ 29:
                    message.perDiemAmountProcessedMeals = reader.string();
                    break;
                case /* int32 per_diem_ignore_first_day_deduction */ 30:
                    message.perDiemIgnoreFirstDayDeduction = reader.int32();
                    break;
                case /* int32 per_diem_ignore_last_day_deduction */ 31:
                    message.perDiemIgnoreLastDayDeduction = reader.int32();
                    break;
                case /* string per_diem_row_zip_code */ 32:
                    message.perDiemRowZipCode = reader.string();
                    break;
                case /* int32 per_diem_row_service_call_id */ 33:
                    message.perDiemRowServiceCallId = reader.int32();
                    break;
                case /* string per_diem_row_notes */ 34:
                    message.perDiemRowNotes = reader.string();
                    break;
                case /* int32 per_diem_row_meals_only */ 35:
                    message.perDiemRowMealsOnly = reader.int32();
                    break;
                case /* string per_diem_row_date */ 36:
                    message.perDiemRowDate = reader.string();
                    break;
                case /* int32 per_diem_row_needs_auditing */ 37:
                    message.perDiemRowNeedsAuditing = reader.int32();
                    break;
                case /* int32 per_diem_row_lodging_request_id */ 38:
                    message.perDiemRowLodgingRequestId = reader.int32();
                    break;
                case /* repeated string date_range */ 39:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 40:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string user_id_list */ 41:
                    message.userIdList = reader.string();
                    break;
                case /* repeated string field_mask */ 42:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 43:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 44:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 45:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 46:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string travel_date = 2; */
        if (message.travelDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.travelDate);
        /* int32 lodging_request_id = 3; */
        if (message.lodgingRequestId !== 0)
            writer.tag(3, WireType.Varint).int32(message.lodgingRequestId);
        /* int32 lodging_assignment_id = 4; */
        if (message.lodgingAssignmentId !== 0)
            writer.tag(4, WireType.Varint).int32(message.lodgingAssignmentId);
        /* int32 lodging_requestor_id = 5; */
        if (message.lodgingRequestorId !== 0)
            writer.tag(5, WireType.Varint).int32(message.lodgingRequestorId);
        /* int32 lodging_job_id = 6; */
        if (message.lodgingJobId !== 0)
            writer.tag(6, WireType.Varint).int32(message.lodgingJobId);
        /* string check_in_date = 7; */
        if (message.checkInDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.checkInDate);
        /* string check_out_date = 8; */
        if (message.checkOutDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.checkOutDate);
        /* int32 lodging_status_id = 9; */
        if (message.lodgingStatusId !== 0)
            writer.tag(9, WireType.Varint).int32(message.lodgingStatusId);
        /* string lodging_notes = 10; */
        if (message.lodgingNotes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.lodgingNotes);
        /* string lodging_admin_notes = 11; */
        if (message.lodgingAdminNotes !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.lodgingAdminNotes);
        /* string lodging_internal_notes = 12; */
        if (message.lodgingInternalNotes !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.lodgingInternalNotes);
        /* string lodging_address = 13; */
        if (message.lodgingAddress !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.lodgingAddress);
        /* int32 lodging_per_diem_type = 14; */
        if (message.lodgingPerDiemType !== 0)
            writer.tag(14, WireType.Varint).int32(message.lodgingPerDiemType);
        /* string lodging_assignment_notes = 15; */
        if (message.lodgingAssignmentNotes !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.lodgingAssignmentNotes);
        /* double lodging_assignment_cost = 16; */
        if (message.lodgingAssignmentCost !== 0)
            writer.tag(16, WireType.Bit64).double(message.lodgingAssignmentCost);
        /* int32 per_diem_id = 17; */
        if (message.perDiemId !== 0)
            writer.tag(17, WireType.Varint).int32(message.perDiemId);
        /* int32 per_diem_row_id = 18; */
        if (message.perDiemRowId !== 0)
            writer.tag(18, WireType.Varint).int32(message.perDiemRowId);
        /* string per_diem_date_started = 19; */
        if (message.perDiemDateStarted !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.perDiemDateStarted);
        /* int32 per_diem_department_id = 20; */
        if (message.perDiemDepartmentId !== 0)
            writer.tag(20, WireType.Varint).int32(message.perDiemDepartmentId);
        /* string per_diem_notes = 21; */
        if (message.perDiemNotes !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.perDiemNotes);
        /* string per_diem_date_submitted = 22; */
        if (message.perDiemDateSubmitted !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.perDiemDateSubmitted);
        /* string per_diem_date_approved = 23; */
        if (message.perDiemDateApproved !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.perDiemDateApproved);
        /* int32 per_diem_approved_by_id = 24; */
        if (message.perDiemApprovedById !== 0)
            writer.tag(24, WireType.Varint).int32(message.perDiemApprovedById);
        /* int32 per_diem_needs_auditing = 25; */
        if (message.perDiemNeedsAuditing !== 0)
            writer.tag(25, WireType.Varint).int32(message.perDiemNeedsAuditing);
        /* int32 payroll_processed = 26; */
        if (message.payrollProcessed !== 0)
            writer.tag(26, WireType.Varint).int32(message.payrollProcessed);
        /* string per_diem_date_processed = 27; */
        if (message.perDiemDateProcessed !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.perDiemDateProcessed);
        /* string per_diem_amount_processed_lodging = 28; */
        if (message.perDiemAmountProcessedLodging !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.perDiemAmountProcessedLodging);
        /* string per_diem_amount_processed_meals = 29; */
        if (message.perDiemAmountProcessedMeals !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.perDiemAmountProcessedMeals);
        /* int32 per_diem_ignore_first_day_deduction = 30; */
        if (message.perDiemIgnoreFirstDayDeduction !== 0)
            writer.tag(30, WireType.Varint).int32(message.perDiemIgnoreFirstDayDeduction);
        /* int32 per_diem_ignore_last_day_deduction = 31; */
        if (message.perDiemIgnoreLastDayDeduction !== 0)
            writer.tag(31, WireType.Varint).int32(message.perDiemIgnoreLastDayDeduction);
        /* string per_diem_row_zip_code = 32; */
        if (message.perDiemRowZipCode !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.perDiemRowZipCode);
        /* int32 per_diem_row_service_call_id = 33; */
        if (message.perDiemRowServiceCallId !== 0)
            writer.tag(33, WireType.Varint).int32(message.perDiemRowServiceCallId);
        /* string per_diem_row_notes = 34; */
        if (message.perDiemRowNotes !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.perDiemRowNotes);
        /* int32 per_diem_row_meals_only = 35; */
        if (message.perDiemRowMealsOnly !== 0)
            writer.tag(35, WireType.Varint).int32(message.perDiemRowMealsOnly);
        /* string per_diem_row_date = 36; */
        if (message.perDiemRowDate !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.perDiemRowDate);
        /* int32 per_diem_row_needs_auditing = 37; */
        if (message.perDiemRowNeedsAuditing !== 0)
            writer.tag(37, WireType.Varint).int32(message.perDiemRowNeedsAuditing);
        /* int32 per_diem_row_lodging_request_id = 38; */
        if (message.perDiemRowLodgingRequestId !== 0)
            writer.tag(38, WireType.Varint).int32(message.perDiemRowLodgingRequestId);
        /* repeated string date_range = 39; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(39, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 40; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(40, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string user_id_list = 41; */
        if (message.userIdList !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.userIdList);
        /* repeated string field_mask = 42; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(42, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 43; */
        if (message.pageNumber !== 0)
            writer.tag(43, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 44; */
        if (message.orderBy !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 45; */
        if (message.orderDir !== "")
            writer.tag(45, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 46; */
        if (message.withoutLimit !== false)
            writer.tag(46, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelDay
 */
export const ScheduleTravelDay = new ScheduleTravelDay$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleTravelDayList$Type extends MessageType {
    constructor() {
        super("ScheduleTravelDayList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleTravelDay },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ScheduleTravelDay results */ 1:
                    message.results.push(ScheduleTravelDay.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ScheduleTravelDay results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ScheduleTravelDay.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ScheduleTravelDayList
 */
export const ScheduleTravelDayList = new ScheduleTravelDayList$Type();
/**
 * @generated ServiceType for protobuf service ScheduleService
 */
export const ScheduleService = new ServiceType("ScheduleService", [
    { name: "CreateScheduleShift", options: {}, I: ScheduleShift, O: ScheduleShift },
    { name: "GetScheduleShift", options: {}, I: ScheduleShift, O: ScheduleShift },
    { name: "BatchGetScheduleShift", options: {}, I: ScheduleShift, O: ScheduleShiftList },
    { name: "UpdateScheduleShift", options: {}, I: ScheduleShift, O: ScheduleShift },
    { name: "DeleteScheduleShift", options: {}, I: ScheduleShift, O: Empty },
    { name: "CreateScheduleCardDraft", options: {}, I: ScheduleCardDraft, O: ScheduleCardDraft },
    { name: "GetScheduleCardDraft", options: {}, I: ScheduleCardDraft, O: ScheduleCardDraft },
    { name: "BatchGetScheduleCardDraft", options: {}, I: ScheduleCardDraft, O: ScheduleCardDraftList },
    { name: "UpdateScheduleCardDraft", options: {}, I: ScheduleCardDraft, O: ScheduleCardDraft },
    { name: "DeleteScheduleCardDraft", options: {}, I: ScheduleCardDraft, O: Empty },
    { name: "CreateScheduleAssignment", options: {}, I: ScheduleAssignment, O: ScheduleAssignment },
    { name: "GetScheduleAssignment", options: {}, I: ScheduleAssignment, O: ScheduleAssignment },
    { name: "BatchGetScheduleAssignment", options: {}, I: ScheduleAssignment, O: ScheduleAssignmentList },
    { name: "UpdateScheduleAssignment", options: {}, I: ScheduleAssignment, O: ScheduleAssignment },
    { name: "DeleteScheduleAssignment", options: {}, I: ScheduleAssignment, O: Empty },
    { name: "MarkScheduleAssignmentSeen", options: {}, I: ScheduleAssignment, O: ScheduleAssignment },
    { name: "BatchGetScheduleAssignmentBoard", options: {}, I: ScheduleAssignmentBoard, O: ScheduleAssignmentBoardList },
    { name: "CreateSchedulePublish", options: {}, I: SchedulePublish, O: SchedulePublish },
    { name: "GetSchedulePublish", options: {}, I: SchedulePublish, O: SchedulePublish },
    { name: "BatchGetSchedulePublish", options: {}, I: SchedulePublish, O: SchedulePublishList },
    { name: "UpdateSchedulePublish", options: {}, I: SchedulePublish, O: SchedulePublish },
    { name: "PublishScheduleAssignments", options: {}, I: SchedulePublish, O: SchedulePublish },
    { name: "CreateScheduleWeekException", options: {}, I: ScheduleWeekException, O: ScheduleWeekException },
    { name: "GetScheduleWeekException", options: {}, I: ScheduleWeekException, O: ScheduleWeekException },
    { name: "BatchGetScheduleWeekException", options: {}, I: ScheduleWeekException, O: ScheduleWeekExceptionList },
    { name: "UpdateScheduleWeekException", options: {}, I: ScheduleWeekException, O: ScheduleWeekException },
    { name: "DeleteScheduleWeekException", options: {}, I: ScheduleWeekException, O: Empty },
    { name: "CreateScheduleLodgingLink", options: {}, I: ScheduleLodgingLink, O: ScheduleLodgingLink },
    { name: "GetScheduleLodgingLink", options: {}, I: ScheduleLodgingLink, O: ScheduleLodgingLink },
    { name: "BatchGetScheduleLodgingLink", options: {}, I: ScheduleLodgingLink, O: ScheduleLodgingLinkList },
    { name: "CreateScheduleLodgingExclusion", options: {}, I: ScheduleLodgingExclusion, O: ScheduleLodgingExclusion },
    { name: "GetScheduleLodgingExclusion", options: {}, I: ScheduleLodgingExclusion, O: ScheduleLodgingExclusion },
    { name: "BatchGetScheduleLodgingExclusion", options: {}, I: ScheduleLodgingExclusion, O: ScheduleLodgingExclusionList },
    { name: "UpdateScheduleLodgingExclusion", options: {}, I: ScheduleLodgingExclusion, O: ScheduleLodgingExclusion },
    { name: "CreateSchedulePerDiemLink", options: {}, I: SchedulePerDiemLink, O: SchedulePerDiemLink },
    { name: "GetSchedulePerDiemLink", options: {}, I: SchedulePerDiemLink, O: SchedulePerDiemLink },
    { name: "BatchGetSchedulePerDiemLink", options: {}, I: SchedulePerDiemLink, O: SchedulePerDiemLinkList },
    { name: "BatchGetScheduleShiftType", options: {}, I: ScheduleShiftType, O: ScheduleShiftTypeList },
    { name: "BatchGetScheduleEntryType", options: {}, I: ScheduleEntryType, O: ScheduleEntryTypeList },
    { name: "BatchGetScheduleAssignmentRole", options: {}, I: ScheduleAssignmentRole, O: ScheduleAssignmentRoleList },
    { name: "BatchGetScheduleTimeoffWindow", options: {}, I: ScheduleTimeoffWindow, O: ScheduleTimeoffWindowList },
    { name: "BatchGetScheduleTravelDay", options: {}, I: ScheduleTravelDay, O: ScheduleTravelDayList },
    { name: "GetScheduleEmailPreview", options: {}, I: ScheduleEmailRequest, O: ScheduleEmail },
    { name: "GetScheduleDepartmentEmailPreview", options: {}, I: ScheduleEmailRequest, O: ScheduleEmail },
    { name: "SendSchedulePublishEmails", options: {}, I: SchedulePublish, O: ScheduleEmailSendResult },
    { name: "SendWeeklyScheduleEmails", options: {}, I: ScheduleEmailRequest, O: ScheduleEmailSendResult },
    { name: "GetScheduleLookahead", options: {}, I: ScheduleLookaheadRequest, O: ScheduleLookahead },
    { name: "BuildScheduleTravel", options: {}, I: ScheduleTravelRequest, O: ScheduleTravelResult },
    { name: "BatchGetScheduleTravelTier", options: {}, I: ScheduleTravelTierRequest, O: ScheduleTravelTierList },
    { name: "BatchGetScheduleConflictType", options: {}, I: ScheduleConflictType, O: ScheduleConflictTypeList },
    { name: "CreateScheduleConflictResolution", options: {}, I: ScheduleConflictResolution, O: ScheduleConflictResolution },
    { name: "GetScheduleConflictResolution", options: {}, I: ScheduleConflictResolution, O: ScheduleConflictResolution },
    { name: "BatchGetScheduleConflictResolution", options: {}, I: ScheduleConflictResolution, O: ScheduleConflictResolutionList },
    { name: "UpdateScheduleConflictResolution", options: {}, I: ScheduleConflictResolution, O: ScheduleConflictResolution },
    { name: "CreateScheduleTradeRequest", options: {}, I: ScheduleTradeRequest, O: ScheduleTradeRequest },
    { name: "GetScheduleTradeRequest", options: {}, I: ScheduleTradeRequest, O: ScheduleTradeRequest },
    { name: "BatchGetScheduleTradeRequest", options: {}, I: ScheduleTradeRequest, O: ScheduleTradeRequestList },
    { name: "UpdateScheduleTradeRequest", options: {}, I: ScheduleTradeRequest, O: ScheduleTradeRequest },
    { name: "DeleteScheduleTradeRequest", options: {}, I: ScheduleTradeRequest, O: Empty },
    { name: "CreateScheduleTeam", options: {}, I: ScheduleTeam, O: ScheduleTeam },
    { name: "GetScheduleTeam", options: {}, I: ScheduleTeam, O: ScheduleTeam },
    { name: "BatchGetScheduleTeam", options: {}, I: ScheduleTeam, O: ScheduleTeamList },
    { name: "UpdateScheduleTeam", options: {}, I: ScheduleTeam, O: ScheduleTeam },
    { name: "DeleteScheduleTeam", options: {}, I: ScheduleTeam, O: Empty },
    { name: "CreateScheduleTeamMember", options: {}, I: ScheduleTeamMember, O: ScheduleTeamMember },
    { name: "GetScheduleTeamMember", options: {}, I: ScheduleTeamMember, O: ScheduleTeamMember },
    { name: "BatchGetScheduleTeamMember", options: {}, I: ScheduleTeamMember, O: ScheduleTeamMemberList },
    { name: "UpdateScheduleTeamMember", options: {}, I: ScheduleTeamMember, O: ScheduleTeamMember },
    { name: "DeleteScheduleTeamMember", options: {}, I: ScheduleTeamMember, O: Empty },
    { name: "BatchGetScheduleActivityType", options: {}, I: ScheduleActivityType, O: ScheduleActivityTypeList },
    { name: "CreateScheduleActivityLog", options: {}, I: ScheduleActivityLog, O: ScheduleActivityLog },
    { name: "GetScheduleActivityLog", options: {}, I: ScheduleActivityLog, O: ScheduleActivityLog },
    { name: "BatchGetScheduleActivityLog", options: {}, I: ScheduleActivityLog, O: ScheduleActivityLogList }
]);
